import React from "react";
import AppRouter from "@router/AppRouter";
import AuthOverlay from "@components/AuthOverlay/AuthOverlay";
import {QueryClientProvider} from "@tanstack/react-query";
import {queryClient} from "@queries/clientConfig";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import SkipLink from "@components/SkipLink/SkipLink";
import {AppModal} from "@components/AppModal/AppModal";

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <SkipLink/>
            <AuthOverlay/>
            <AppModal/>
            <AppRouter/>
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false}/>}
        </QueryClientProvider>
    );
}

